import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useActualiseTransaction({ id } = {}) {
  const queryClient = useQueryClient()

  const action = async ({ actual_amount } = {}) => {
    const payload = {}
    if (actual_amount !== undefined && actual_amount !== null) {
      payload.actual_amount = actual_amount
    }
    const response = await httpClient.post(
      `/team/cash-flow/transactions/${id}/actualise`,
      payload,
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['transactions'] })
      queryClient.invalidateQueries({ queryKey: ['models'] })
      toast.success('Transaction actualised successfully.')
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
